<div class="d-flex flex-column">
  <span class="italic d-inline-flex w-25" *ngIf="to.label">{{
    to.resourceId ? (to.resourceId | apmTranslate) : to.label
  }}</span>
  <div class="d-flex flex-column flex-1" *ngFor="let field of field.fieldGroup">
    <formly-field [field]="field"></formly-field>
  </div>
</div>
